/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: garry彭
 * @LastEditTime: 2023-08-08 10:47:11
 */
import React from 'react'
import { Badge } from 'antd'
import { setPaymentVisible } from '../../../../actions/main'
import { useAppDispatch, useAppSelector } from '../../../../app/hooks'
import vip_badge_img from '../../../../images/vip_badge.png'
import sensors from 'sa-sdk-javascript'

interface IAdvance {
  onCancel: () => void
  onOk: () => void
}

const Advance: React.FC<IAdvance> = ({
  onCancel = () => {},
  onOk = () => {}
}) => {
  const dispatch = useAppDispatch()

  const group = useAppSelector((store) => store.group)

  const onPay = () => {
    dispatch(setPaymentVisible(true, 'photoFolderDownloadFolder'))

    sensors.track('web_click_button_workgroup_go_vip_trigger', {
      place: 'photoFolder',
      functionType: 'downloadPhoto',
      groupID: group.groupId
    })
  }

  return (
    <div className="albums-modal-advance">
      <div className="desc">仅团队会员支持文件夹下载</div>

      <div className="actions">
        <div className="btn-cancel" onClick={onCancel}>
          取消
        </div>

        <Badge count={<img src={vip_badge_img} />}>
          <div
            className="btn-confirm"
            onClick={() => {
              onOk()
              onPay()
            }}
          >
            开通后下载
          </div>
        </Badge>
      </div>
    </div>
  )
}

export default Advance
